import styled from "styled-components";
import nflFirst from "../../assets/img/nflFirst.png";

export const DraftRoomV2Wrapper = styled.div`
  font-family: -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Arial","Helvetica Neue","Helvetica",sans-serif;
  background: #f4f6f8;
  color: #101418;
  width: 100%;
  position: relative;
  .draft-loading {
    position: fixed;
    inset: 0;
    background: #2f2f2f;
    color: #ffffff;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 18px;
    z-index: 20;
  }
  .draft-loading .logo {
    width: 120px;
    height: 120px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .draft-loading .logo img {
    width: 88px;
    height: 88px;
    object-fit: contain;
  }
  .draft-loading .dots {
    display: flex;
    gap: 10px;
  }
  .draft-loading .dots span {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #ffffff;
    opacity: 0.6;
    animation: draftPulse 1.2s infinite ease-in-out;
  }
  .draft-loading .dots span:nth-child(1) { animation-delay: 0s; }
  .draft-loading .dots span:nth-child(2) { animation-delay: 0.15s; }
  .draft-loading .dots span:nth-child(3) { animation-delay: 0.3s; }
  .draft-loading .dots span:nth-child(4) { animation-delay: 0.45s; }
  .draft-loading .dots span:nth-child(5) { animation-delay: 0.6s; }
  .draft-loading .text {
    font-size: 13px;
    letter-spacing: 0.4px;
    color: #d1d5db;
  }
  .event-finished-modal {
    width: min(860px, 100%);
    background: #ececef;
    border-radius: 6px;
    padding: 56px 40px 48px;
    text-align: center;
  }
  .event-finished-modal h2 {
    margin: 0;
    color: rgb(1, 25, 69);
    font-size: 32px;
    font-family: 'Saira Semi Condensed', sans-serif;
    font-weight: 700;
    line-height: 1.05;
  }
  .event-finished-modal .divider {
    width: 100%;
    max-width: 500px;
    height: 1px;
    background: #c8cbd1;
    margin: 34px auto 28px;
  }
  .event-finished-modal p {
    margin: 0;
    color: #101418;
    font-size: 20px;
    font-family: 'Saira Semi Condensed', sans-serif;
  }
  .event-finished-modal .home-link {
    border: none;
    background: transparent;
    color: #1a5fff;
    font: inherit;
    cursor: pointer;
    padding: 0;
  }
  @media (max-width: 768px) {
    .event-finished-modal {
      padding: 36px 18px 30px;
    }
    .event-finished-modal p {
      font-size: 24px;
    }
  }
  @keyframes draftPulse {
    0%, 100% { opacity: 0.2; transform: scale(0.9); }
    50% { opacity: 1; transform: scale(1); }
  }
`;

export const DraftTopBar = styled.div`
  background: rgb(10, 33, 13);
  color: rgb(233, 247, 235);
  border-bottom: 2px solid rgb(10, 42, 15);
  padding: 4px 12px;
  overflow: hidden;
`;

export const TopBarRow = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
`;

export const TimerBox = styled.div`
  background: #0b1f0d;
  border: 1px solid #1c4b20;
  border-radius: 6px;
  padding: 8px;
  text-align: center;
  font-weight: 700;
  color: #7cff8a;
  width: 105px;
  flex: none;
  height: 72px;
  .label {
    font-size: 11px;
    letter-spacing: 0.6px;
    color: #d5e9d8;
  }
  .time {
    font-size: 22px;
    line-height: 22px;
    margin-top: 6px;
  }
`;

export const OnTheClockCard = styled.div`
  &.current-pick-module-container {
    background-color: rgb(5, 48, 3);
    color: rgb(255, 255, 255);
    cursor: pointer;
    height: 72px;
    user-select: none;
    width: 280px;
    flex: none;
    border: 1px solid rgb(31, 92, 39);
    border-radius: 4px;
  }
  .Image {
    margin: 0;
    max-width: 100%;
    position: relative;
  }
  .clr-white {
    color: #fff;
  }
  .fl {
    float: left;
  }
  .ttu {
    text-transform: uppercase;
  }
  .contents {
    height: 100%;
    padding: 17px;
    width: 100%;
  }
  .contents.own-pick {
    background-color: rgb(45, 204, 48);
  }
  .team-logo {
    margin: 0 18px 4px 0;
    padding: 2px 0;
  }
  .team-logo.team-logo-vector {
    filter: drop-shadow(rgb(255, 255, 255) 1px 0px)
      drop-shadow(rgb(255, 255, 255) 0px 1px)
      drop-shadow(rgb(255, 255, 255) -1px 0px)
      drop-shadow(rgb(255, 255, 255) 0px -1px);
  }
  .on-the-clock {
    font-size: 12px;
    letter-spacing: 0.5px;
    margin-bottom: 4px;
  }
  .team-name {
    font-size: 19px;
    font-weight: 500;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .croppable-image img.Image {
    height: 100%;
    width: 100%;
  }
`;

export const OnTheClockIcon = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 10px;
  background: #142f18;
  border: 1px solid #1f5c27;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  overflow: hidden;
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

export const OnTheClockText = styled.div`
  .eyebrow {
    font-size: 11px;
    letter-spacing: 0.6px;
    text-transform: uppercase;
    color: #d5e9d8;
  }
  .team {
    font-size: 18px;
    font-weight: 700;
    color: #e9f7eb;
    margin-top: 4px;
  }
`;

export const PickStrip = styled.div`
  display: flex;
  gap: 6px;
`;

export const PickTile = styled.div`
  background: rgb(5, 48, 3);
  border: 1px solid #1f5c27;
  border-radius: 4px;
  padding: 6px 6px;
  text-align: center;
  font-size: 11px;
  line-height: 14px;
  color: #f1f2f3;
  position: relative;
  height: 72px;
  width: 86px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  &.round-tile {
    background: #0b1f0d;
    border-color: #1c4b20;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 2px;
  }
  &.active {
    background: #2dcc30;
    color: #000000;
    border-color: #1d8d24;
    font-weight: 700;
  }
  &.own-pick {
    background: #2dcc30;
    color: #000000;
    border-color: #1d8d24;
    font-weight: 700;
  }
  &.own-pick .auto-word,
  &.own-pick .user-word,
  &.own-pick .pick-label,
  &.own-pick .pick-team {
    color: #000000;
  }
  &.active .auto-word {
    color: #000000;
  }
  &.active .pick-label,
  &.active .pick-team {
    color: #000000;
  }
  &.autopick .pick-team {
    opacity: 0.7;
  }
  &.autopick .pick-logo {
    opacity: 0.3;
  }
  .user-word {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 13px;
    font-weight: 700;
    color: #2b6dde;
    z-index: 2;
    pointer-events: none;
  }
  .pick-label {
    font-size: 10px;
    letter-spacing: 0.4px;
    text-transform: uppercase;
  }
  .auto-word {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 13px;
    font-weight: 700;
    color: #2dcc30;
    z-index: 2;
    pointer-events: none;
  }
  .pick-logo {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background: #0b1f0d;
    border: 1px solid #1c4b20;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    position: relative;
    z-index: 1;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
  .pick-team {
    font-size: 10px;
    color: #d0e5d3;
    max-width: 90%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .round-label {
    font-size: 10px;
    letter-spacing: 0.8px;
    text-transform: uppercase;
    color: #d5e9d8;
  }
  .round-number {
    font-size: 18px;
    font-weight: 700;
    color: #e9f7eb;
  }
`;

export const DraftRoomV2Grid = styled.div`
  display: flex;
  grid-template-columns: 250px 1fr 260px;
  gap: 12px;
  padding: 12px;
  flex: 1;
  height: calc(100vh - 90px - 82px);
  overflow: hidden;
`;

export const Panel = styled.div`
  background: #ffffff;
  border: 1px solid #e1e5ea;
  border-radius: 6px;
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.06);
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex: none;
  -ms-flex: none;
  flex: none;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  width: 268px;
`;

export const PanelHeader = styled.div`
  padding: 10px 12px;
  border-bottom: 1px solid #e8edf2;
  font-size: 14px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const PanelBody = styled.div`
  padding: 10px 12px;
`;

export const PanelBodyScroll = styled.div`
  padding: 10px 12px;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  overflow-x: hidden;
  overflow-y: auto;
  width: 100%;
`;

export const ToggleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 12px;
  color: #3a4450;
  input {
    accent-color: #2cba35;
  }
`;

export const MiniTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
  th,
  td {
    text-align: left;
    padding: 6px 4px;
    border-bottom: 1px solid #eef1f4;
  }
  th {
    color: #101418;
    font-weight: 700;
  }
  td {
    color: #485260;
  }
  .queue-btn {
    border: 1px solid #c9cfd8;
    background: #fff;
    border-color: rgb(108, 109, 111);
    color: rgb(108, 109, 111);
    border-radius: 50px;
    text-transform: uppercase;
    transition: all 0.25s ease-in-out;
    cursor: pointer;
    font-size: 11px;
    height: 28px;
    padding: 0 12px;
  }
  .queue-btn.queued {
    background: #3a3a3a;
    color: #ffffff;
    border-color: #3a3a3a;
    cursor: pointer;
  }
  .draft-btn {
    border: 1px solid #e32525;
    background: #fff;
    color: #e32525;
    border-radius: 50px;
    text-transform: uppercase;
    transition: all 0.25s ease-in-out;
    cursor: pointer;
    font-size: 11px;
    height: 28px;
    padding: 0 12px;
  }
  .draft-btn:hover {
    border-color: transparent;
    color: #ffffff;
    background: #e32525;
  }
`;

export const MainPanel = styled(Panel)`
  display: flex;
  flex-direction: column;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  min-width: 0;
`;

export const DraftStatus = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  padding: 14px 16px;
  border-bottom: 1px solid #e8edf2;
  &.autopick {
    background: rgb(13 194 64);
  }
`;

export const StatusAvatar = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: #f1f4f8;
  border: 1px solid #d9e0e8;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  font-weight: 700;
  overflow: hidden;
  &.autopick {
    width: 44px;
    height: 44px;
    font-size: 13px;
    color: #0f3a14;
    background: rgba(12, 68, 17, 0.22);
    border-color: rgba(12, 68, 17, 0.38);
  }
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const StatusText = styled.div`
  flex: 1;
  min-width: 180px;
  .title {
    font-size: 18px;
    font-weight: 700;
    color: #101418;
  }
  .subtitle {
    font-size: 12px;
    color: #5b6675;
  }
  &.autopick .title {
    color: #ffffff;
  }
  &.autopick .subtitle {
    color: #e8ffe9;
  }
`;

export const AutopickActionButton = styled.button`
  margin-left: auto;
  flex: none;
  height: 32px;
  border-radius: 999px;
  border: 1px solid #8f98a3;
  background: #f3f4f6;
  color: #4b5563;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.2px;
  text-transform: uppercase;
  padding: 0 16px;
  cursor: pointer;
  &:hover {
    background: #ffffff;
  }
`;

export const TabRow = styled.div`
  display: flex;
  gap: 18px;
  padding: 8px 16px 0;
  border-bottom: 1px solid #e8edf2;
`;

export const Tab = styled.button`
  background: transparent;
  border: none;
  padding: 10px 0;
  font-size: 13px;
  font-weight: 700;
  color: #5b6675;
  border-bottom: 3px solid transparent;
  cursor: pointer;
  &.active {
    color: #101418;
    border-bottom-color: #2cba35;
  }
`;

export const FilterBar = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  border-bottom: 1px solid #e8edf2;
  flex-wrap: wrap;
`;

export const PillSelect = styled.div`
  border: 1px solid #d6dde5;
  border-radius: 18px;
  padding: 6px 10px;
  font-size: 12px;
  color: #3a4450;
  background: #f9fafb;
`;

export const SearchInput = styled.input`
  margin-left: auto;
  border: 1px solid #d6dde5;
  border-radius: 6px;
  padding: 6px 10px;
  font-size: 12px;
  min-width: 200px;
`;

export const PlayerTableWrap = styled.div`
  padding: 0 16px 16px;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  overflow-y: auto;
  overflow-x: auto;
  width: 100%;
`;

export const DraftCompleteMessage = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 600;
  color: #101418;
  text-align: center;
  padding: 40px 16px;
`;

export const PlayerTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  min-width: 860px;
  font-size: 12px;
  th,
  td {
    padding: 8px 6px;
    border-bottom: 1px solid #eef1f4;
    text-align: left;
    white-space: nowrap;
    font-size: 12px;
  }
  th {
    font-size: 12px;
    color: #222a35;
    letter-spacing: 0.4px;
    position: sticky;
    top: 0;
    background: #ffffff;
    z-index: 2;
  }
  &.pick-history-table th {
    position: static;
  }
  td {
    color: #485260;
  }
  .cell.even:not(.header-cell) {
    background: rgba(0, 0, 0, 0.02);
  }
  th:nth-child(1),
  td:nth-child(1) {
    width: 40px;
  }
  th:nth-child(2),
  td:nth-child(2) {
    width: 40px;
  }
  .player-name {
    color: #1463ff;
    font-weight: 700;
    font-size: 12px;
  }
  .queue-btn {
    border: 1px solid #c9cfd8;
    background: #fff;
    border-color: rgb(108, 109, 111);
    color: rgb(108, 109, 111);
    border-radius: 50px;
    text-transform: uppercase;
    transition: all 0.25s ease-in-out;
    cursor: pointer;
    font-size: 11px;
    height: 28px;
    width: 70px;
    text-align: center;
  }
  .queue-btn:hover {
    border-color: transparent;
    color: #ffffff;
    background: #868789;
  }
  .queue-btn.queued {
    background: #868789;
    color: #ffffff;
    cursor: pointer;
  }
  .draft-btn {
    border: 1px solid #e32525;
    background: #fff;
    color: #e32525;
    border-radius: 50px;
    text-transform: uppercase;
    transition: all 0.25s ease-in-out;
    cursor: pointer;
    font-size: 11px;
    height: 28px;
    padding: 0 12px;
  }
  .draft-btn:hover {
    border-color: transparent;
    color: #ffffff;
    background: #e32525;
  }
  .draft-btn:disabled {
    background: #ffffff;
    color: #b9c0c8;
    border-color: #d6dde5;
    cursor: not-allowed;
  }
  .queue-actions {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 8px;
  }
  .queue-row {
    cursor: grab;
  }
  .queue-row:active {
    cursor: grabbing;
  }
  .queue-btn:disabled {
    background: #ffffff;
    color: #b9c0c8;
    border-color: #d6dde5;
    cursor: not-allowed;
  }
  .pos-pill {
    display: inline-block;
    padding: 4px 10px;
    border-radius: 20px;
    font-size: 12px;
    color: rgb(31, 41, 55);
    width: 50px;
    text-align: center;
  }
`;

export const PicksList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 12px;
  flex: 1 1 0%;
  overflow: auto;
  width: 100%;
`;

export const PickCard = styled.div`
  border: 1px solid #eef1f4;
  border-radius: 8px;
  padding: 8px 10px;
  background: #ffffff;
  display: flex;
  align-items: center;
  gap: 10px;
  .avatar {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background: #e7e9ee;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
  .name {
    font-size: 12px;
    font-weight: 700;
    color: #1f2937;
  }
  .meta {
    font-size: 11px;
    color: #6b7280;
  }
`;

export const DraftCompleteModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 60;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
`;

export const DraftCompleteModalCard = styled.div`
  width: min(700px, 100%);
  max-height: 80vh;
  border-radius: 8px;
  background: #ececef;
  overflow: hidden;
  display: flex;
  flex-direction: column;
   position: relative;
`;

export const DraftCompleteModalHeader = styled.div`
  height: 120px;
  background: linear-gradient(97.81deg, rgb(0, 67, 139) 0%, rgb(7, 201, 62) 0.01%, rgb(29, 169, 69) 13.54%, rgb(32, 164, 70) 15.63%, rgb(60, 123, 78) 32.81%, rgb(0, 67, 139) 58.85%, rgba(0, 67, 139, 0.76) 94.27%);
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  h2 {
    margin: 0;
    font-size: 30px;
    font-weight: 700;
    line-height: 1.05;
    letter-spacing: 0.2px;
  }
  @media (max-width: 640px) {
    h2 {
      font-size: 32px;
    }
  }
`;

export const DraftCompleteModalClose = styled.button`
  position: absolute;
  top: 14px;
  right: 14px;
  width: 28px;
  height: 28px;
  border: none;
  background: transparent;
  color: #ffffff;
  font-size: 28px;
  line-height: 1;
  cursor: pointer;
`;

export const DraftCompleteModalBody = styled.div`
  background-color: #e2e2e5;
  background-image: url(${nflFirst});
  background-position: bottom;
  background-repeat: no-repeat;
  background-size: cover;
  border-bottom: 1px solid rgb(220, 221, 223);
  height: 450px;
  padding: 30px 20px;
  overflow: hidden auto;
  .modal-empty {
    font-family: 'Saira Semi Condensed', sans-serif;
    color: #ffffff;
    font-size: 18px;
    text-align: center;
    padding-top: 40px;
  }
  .modal-list {
    display: flex;
    flex-direction: column;
    gap: 2px;
  }
  .result-row {
    display: flex;
    align-items: stretch;
    min-height: 100px;
    border: 1px solid rgba(255, 255, 255, 0.8);
    background: rgba(0, 16, 54, 0.5);
  }
  .result-row:first-child {
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    overflow: hidden;
  }
  .result-row:last-child {
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    overflow: hidden;
  }
  .round-cell {
    width: 64px;
    flex: none;
    background: rgba(255, 255, 255, 0.9);
    color: #1b2736;
    font-family: 'Saira Semi Condensed', sans-serif;
    font-size: 18px;
    font-weight: 700;
    letter-spacing: 0.2px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-transform: uppercase;
  }
  .player-cell {
    flex: 1;
    min-width: 0;
    display: flex;
    align-items: center;
    gap: 14px;
    padding: 0 18px;
  }
  .team-logo {
    width: 44px;
    height: 44px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.06);
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
  .player-info .name {
    margin: 0;
    color: #ffffff;
    font-family: 'Saira Semi Condensed', sans-serif;
    font-size: 24px;
    font-weight: 700;
    line-height: 1;
    text-transform: uppercase;
  }
  .player-info .school {
    margin: 6px 0 0;
    color: rgba(255, 255, 255, 0.95);
    font-family: 'Saira Semi Condensed', sans-serif;
    font-size: 18px;
    font-weight: 600;
    line-height: 1;
    text-transform: uppercase;
  }
  .pos-cell {
    width: 72px;
    flex: none;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 16px;
  }
  .pos-cell span {
    width: 60px;
    height: 42px;
    border-radius: 8px;
    border: 3px solid #ffffff;
    color: #ffffff;
    font-family: 'Saira Semi Condensed', sans-serif;
    font-size: 18px;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    text-transform: uppercase;
  }
`;

export const DraftCompleteModalFooter = styled.div`
  height: 70px;
  background: #ececef;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  color: #101418;
  font-size: 14px;
`;

export const DraftCompleteModalCopyButton = styled.button`
  height: 32px;
  min-width: 120px;
  border-radius: 999px;
  border: 1px solid #2b6dde;
  background: #f5f8ff;
  color: #2b6dde;
  font-size: 14px;
  font-weight: 700;
  padding: 0 18px;
  cursor: pointer;
`;

export const RightPanelTabRow = styled.div`
  display: flex;
  border-bottom: 1px solid #e8edf2;
`;

export const RightPanelTab = styled.button`
  flex: 1;
  background: transparent;
  border: none;
  padding: 10px 0;
  font-size: 12px;
  font-weight: 700;
  color: #5b6675;
  border-bottom: 3px solid transparent;
  cursor: pointer;
  &.active {
    color: #101418;
    border-bottom-color: #2cba35;
  }
`;

export const TradeOfferCard = styled.div`
  border: 1px solid #eef1f4;
  border-radius: 8px;
  padding: 10px;
  background: #ffffff;
  margin-bottom: 8px;
  &.pending {
    border-color: #fbbf24;
  }
  &.accepted {
    border-color: #2cba35;
  }
  &.rejected {
    border-color: #ef4444;
  }
  &.cancelled {
    border-color: #d1d5db;
    opacity: 0.7;
  }
  .trade-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 6px;
  }
  .trade-teams {
    font-size: 11px;
    font-weight: 700;
    color: #1f2937;
    display: flex;
    align-items: center;
    gap: 4px;
  }
  .trade-status {
    font-size: 10px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.4px;
    padding: 2px 8px;
    border-radius: 10px;
  }
  .trade-status.pending {
    background: #fef3c7;
    color: #92400e;
  }
  .trade-status.accepted {
    background: #d1fae5;
    color: #065f46;
  }
  .trade-status.rejected {
    background: #fee2e2;
    color: #991b1b;
  }
  .trade-status.cancelled {
    background: #f3f4f6;
    color: #6b7280;
  }
  .trade-players {
    display: flex;
    gap: 8px;
    margin-bottom: 6px;
  }
  .trade-side {
    flex: 1;
    min-width: 0;
  }
  .trade-side-label {
    font-size: 10px;
    color: #6b7280;
    text-transform: uppercase;
    letter-spacing: 0.3px;
    margin-bottom: 3px;
    font-weight: 600;
  }
  .trade-side-names {
    font-size: 11px;
    color: #374151;
    line-height: 1.4;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .trade-note {
    font-size: 11px;
    color: #6b7280;
    font-style: italic;
    margin-bottom: 6px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .trade-actions {
    display: flex;
    gap: 6px;
  }
  .trade-actions button {
    flex: 1;
    height: 26px;
    border-radius: 4px;
    font-size: 11px;
    font-weight: 700;
    cursor: pointer;
    border: 1px solid;
    text-transform: uppercase;
    letter-spacing: 0.3px;
  }
  .btn-accept {
    background: #2cba35;
    color: #ffffff;
    border-color: #2cba35;
  }
  .btn-accept:hover {
    background: #25a02e;
  }
  .btn-reject {
    background: #ffffff;
    color: #ef4444;
    border-color: #ef4444;
  }
  .btn-reject:hover {
    background: #fef2f2;
  }
  .btn-cancel {
    background: #ffffff;
    color: #6b7280;
    border-color: #d1d5db;
  }
  .btn-cancel:hover {
    background: #f9fafb;
  }
`;

export const TradeGroupLabel = styled.div`
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  color: #9ca3af;
  padding: 8px 0 4px;
`;

export const TradesEmpty = styled.div`
  padding: 24px 12px;
  text-align: center;
  color: #9ca3af;
  font-size: 12px;
`;
